module.exports = __webpack_public_path__ + "img/case-banner.cc53f0e8.png";